import { WebLayout } from "@/components/shared/layout/homepage.web";
import { RescheduleVisit } from "@/containers/visits/reschedule-visit";
import { Navigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

export function RescheduleVisitPage() {
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const id = searchParams.get("id");
  const value = token || id;

  if (!value) {
    return <Navigate to={"/" + ROUTES.Visits.Root} />;
  }

  return (
    <WebLayout>
      <RescheduleVisit {...{ [token ? "token" : "visitId"]: value }} />
    </WebLayout>
  );
}
